module.exports = __webpack_public_path__ + "static/img/格物智安工地安全管理平台操作说明-5.6b49eff.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/documentation/格物智安工地安全管理平台操作说明-5.jpg
// module id = PPud
// module chunks = 0